// Vue.js
import Vue from 'vue';
// Axios
import axios from 'axios';
import VueAxios from 'vue-axios';
// Element.js
import Element from 'element-ui';
import lang from 'element-ui/lib/locale/lang/zh-TW';
import locale from 'element-ui/lib/locale';
import 'element-ui/lib/theme-chalk/index.css';
// VueRouter
import router from './router';
// 入口點
import app from './entry/app.vue';
// 全域設定
Vue.config.productionTip = false;
Vue.config.silent = true;
Vue.config.devtools = process.env.NODE_ENV !== 'production';
// 全域載入使用
Vue.use(VueAxios, axios);
Vue.use(Element, { locale });
locale.use(lang);
new Vue({
    router,
    components: { app },
    render: h => h(app)
}).$mount('#app');
